import httpClient from "@/services/httpClient";
import {
    server
} from "@/services/constants";

export const getCHAGE_MASTER_RECORD_BYID = (id) => {
    return httpClient.get(server.CHAGE_MASTER_RECORD + `/${id}`);
};
export const createCHAGE_MASTER_RECORD = (data) => {
    return httpClient.post(server.CHAGE_MASTER_RECORD, data);
};

export const updateCHAGE_MASTER_RECORD = (id, data) => {
    return httpClient.put(server.CHAGE_MASTER_RECORD + `/${id}`, data);
};